import $ from "jquery";
import Cookies from "js-cookie";

const $cookiesEl = $(".cookies");
const $cookiesBar = $(".cookies__bar");
const $cookiesConsent = $(".cookies__consent");
const $cookiesDecline = $(".cookies-decline");
const $cookiesConsentAll = $(".cookies__consent_all");
const $cookiesConsentCustom = $(".cookies__consent_custom");
const $cookiesTrigger = $(".cookies-trigger");

$(function () {
  const cookie_cnsnt = Cookies.get("cookie_cnsnt");

  if (cookie_cnsnt === undefined) {
    $cookiesBar.slideUp(0).slideDown(500);
    $(".cookies__desc-link").trigger("focus");
  } else {
    initCookieFunctions(cookie_cnsnt);
  }

  $cookiesConsent.on("click", function () {
    acknowledgeCookies(true);
    $cookiesBar.slideUp();
  });
  $cookiesConsentAll.on("click", function () {
    acknowledgeCookies(true);
    $cookiesBar.slideUp();
  });
  $cookiesDecline.on("click", function () {
    Cookies.set("cookie_cnsnt", "required", { expires: 120 });
    $cookiesBar.slideUp();
  });
  $cookiesConsentCustom.on("click", function () {
    acknowledgeCookies();
    $cookiesBar.slideUp();
  });
});

function acknowledgeCookies(all = false) {
  let categories = [];

  if (all === true) {
    $cookiesEl.find(".checkbox-switch__input").each(function () {
      categories.push($(this).data("category"));
    });
  } else {
    $cookiesEl.find(".checkbox-switch__input:checked").each(function () {
      categories.push($(this).data("category"));
    });
  }

  categories = categories.join(",");
  Cookies.set("cookie_cnsnt", categories, { expires: 120 });

  initCookieFunctions(categories);
}

function initCookieFunctions(cookie_cnsnt) {
  const categories = cookie_cnsnt.split(",");

  categories.forEach(function (category) {
    switch (category) {
      case "analytics":
        initGoogleAnalytics();
        break;
    }
  });

  if (!categories.includes("analytics")) {
    disableGoogleAnalytics();
  }
}

function initGoogleAnalytics() {
  $cookiesEl.find(`[data-category=analytics]`).prop("checked", true);

  gtag("consent", "update", {
    analytics_storage: "granted",
  });
}

function disableGoogleAnalytics() {
  gtag("consent", "update", {
    analytics_storage: "denied",
  });
}

function gtag() {
  dataLayer.push(arguments);
}

// cookies modal behaviour

const $document = $(document);
const $cookiesClose = $("#cookies-modal-close");
const $targetCheckbox = $(".checkbox-switch__slider--analytic");
const $targetCheckboxInput = $("#analytical_checkbox");

$(function () {
  $document.on("click", ".cookies-trigger", function () {
    const $targetModal = $($(this).data("target"));
    openCookiesModal($targetModal);
    $cookiesClose.trigger("focus");
  });
  $document.on("click", ".cookies-modal-close", function () {
    const $targetModal = $(this).closest(".cookies-modal");
    closeCookiesModal($targetModal);
    $cookiesTrigger.trigger("focus");
  });
  $document.on("keydown", function (event) {
    const $targetModal = $document.find(".cookies-modal.active");
    if (event.key === "Escape") {
      closeCookiesModal($targetModal);
      $cookiesTrigger.trigger("focus");
    }
  });
  $document.on("click", ".cookies-modal", function () {
    closeCookiesModal($(this));
  });
  $document.on("click", ".cookies__content > *", function (event) {
    event.stopImmediatePropagation();
  });
  $cookiesClose.on("keydown", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      event.preventDefault();
      $cookiesConsentCustom.trigger("focus");
    }
  });
  $cookiesConsentCustom.on("keydown", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      event.preventDefault();
      $targetCheckboxInput.trigger("focus");
    } else if (event.key === "Tab") {
      event.preventDefault();
      $cookiesClose.trigger("focus");
    }
  });
  $document.on("focus", ".checkbox-switch__input", function (event) {
    $targetCheckbox.addClass("active");
  });
  $document.on("focusout", ".checkbox-switch__input", function (event) {
    $targetCheckbox.removeClass("active");
  });
  $cookiesTrigger.on("keydown", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      console.log("s");
      event.preventDefault();
      $(".cookies__consent_decline").trigger("focus");
    } else if (event.key === "Tab") {
      event.preventDefault();
      $(".cookies__desc-link").trigger("focus");
    }
  });
  $document.on("keydown", ".cookies__desc-link", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      console.log("s");
      event.preventDefault();
      $cookiesTrigger.trigger("focus");
    }
  });
});

export function openCookiesModal(targetModal) {
  if (targetModal !== undefined) {
    if (!targetModal.hasClass("active")) {
      targetModal.trigger(".cookies-modal:opening");
      targetModal.addClass("active").one("transitionend", function () {
        targetModal.trigger(".cookies-modal:opened");
      });
    }
  }
}

export function closeCookiesModal(targetModal) {
  if (targetModal !== undefined) {
    if (targetModal.hasClass("active")) {
      targetModal.trigger("cookies-modal:closing");
      targetModal.removeClass("active").one("transitionend", function () {
        targetModal.trigger("cookies-modal:closed");
      });
    }
  }
}
